import axios from "axios";

export function initHttp() {
    // Automatically switches based on how you run the app
    if (process.env.REACT_APP_API_BASE_URL) {
        axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
    } else if (process.env.NODE_ENV === 'development') {
        // Run 'npm start': Uses local backend
        axios.defaults.baseURL = 'http://localhost:8080';
    } else {
        // Run 'npm run build': Uses production URL
        axios.defaults.baseURL = 'https://iepnepal.com/api';
    }
    return axios.interceptors.request.use(function (config) {

        const isAuthEndpoint = config.url?.includes('/auth/');
        if (!isAuthEndpoint) {
            const userStr = localStorage?.getItem('user');
            if (userStr) {
                try {
                    const token = JSON.parse(userStr);
                    if (token?.access_token) {
                        config.headers.Authorization = `Bearer ${token.access_token}`;
                    }
                } catch (e) {
                    console.error("Error parsing user token from localstorage", e);
                }
            }
        }
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });


}
